import * as React from 'react';

const SvgExclamationCircleSolid = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 25 25"
		width="1em"
		height="1em"
		{...props}
	>
		<path
			fill="#60636B"
			fillRule="evenodd"
			d="M2.719 12.76c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.366 9.75-9.75 9.75-9.75-4.366-9.75-9.75m10.75-3a1 1 0 0 0-2 0v3.75a1 1 0 1 0 2 0zm-1 5.75a1 1 0 0 0-1 1v.007a1 1 0 0 0 1 1h.007a1 1 0 0 0 1-1v-.008a1 1 0 0 0-1-1z"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgExclamationCircleSolid;
